import { Building2 } from 'lucide-react';
import { PlaceholderPage } from '../PlaceholderPage';

export function DepartmentsPage() {
  return <PlaceholderPage title="Departments" session={9} icon={Building2} />;
}
